export default __webpack_public_path__ + "static/media/certifi_09.6398e546.png";